<template>
  <button
    class="purchase-btn"
    :class="{ 'purchase-arrow': isArrow }"
    @click.stop="handleSquareBtnClick"
  >
    {{ localizedText }}
  </button>
</template>

<script>
import t from '@/plugins/i18n';

export default {
  name: 'SimpleBuyButton',
  mixins: [t],

  props: {
    text: {
      type: String,
      default: null,
    },
    isArrow: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    localizedText() {
      return this.text || this.t('購入');
    },
  },

  methods: {
    handleSquareBtnClick() {
      this.$emit('handleSquareBtnClick');
    },
  },
};
</script>

<style lang="scss" scoped>
.purchase-btn {
  background: #ffffff;
  color: #555;
  font-size: 14px;
  font-weight: bold;
  border: none;
  border-radius: 9999px;
  padding: 10px 20px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease;
  white-space: nowrap;
  min-width: 120px;

  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.25),
    0 0 0 2px rgba(255, 255, 255, 0.9) inset;

  &:hover {
    opacity: 0.9;
  }
  &:active {
    opacity: 0.8;
  }
}

.purchase-arrow {
  position: relative;
}
.purchase-arrow::before,
.purchase-arrow::after {
  content: '';
  position: absolute;
  right: 14px;
  width: 2px;
  height: 12px;
  background: #555;
  transform-origin: center;
}
.purchase-arrow::before {
  transform: rotate(45deg);
  top: 50%;
  margin-top: -1px;
}
.purchase-arrow::after {
  transform: rotate(-45deg);
  top: 50%;
  margin-top: -11px;
}

@media (max-width: 768px) {
  .purchase-btn {
    padding: 12px 20px;
    font-size: 15px;
    min-width: 100px;
  }
  .purchase-arrow::before,
  .purchase-arrow::after {
    right: 10px;
    height: 9px;
  }
}
</style>
